<!-- PackNfcIcon.vue -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="'0 0 64 64'"
    :width="size"
    :height="size"
    role="img"
    aria-label="Bundle NFC icon"
    :style="svgVars"
  >
    <rect x="8" y="18" width="48" height="32" rx="3" :fill="box" />
    <rect x="8" y="12" width="48" height="10" rx="3" :fill="lid" />

    <rect x="30" y="12" width="4" height="38" :fill="ribbonCenter" />

    <g transform="translate(28,6)">
      <path d="M8 6 C4 2 0 2 0 6 C0 10 8 12 8 6 Z" :fill="bowLeft" />
      <path d="M8 6 C12 2 16 2 16 6 C16 10 8 12 8 6 Z" :fill="bowRight" />
    </g>

    <g transform="translate(18,28)">
      <path
        d="M18 6c0 6-9 12-9 12"
        fill="none"
        :stroke="iconColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M14 6c0 4-6 8-6 8"
        fill="none"
        :stroke="iconColor"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <circle cx="4" cy="6" r="1.3" :fill="iconColor" />
    </g>

    <ellipse cx="32" cy="55" rx="20" ry="4" :fill="shadow" />
  </svg>
</template>

<script>
export default {
  name: "PackNfcIcon",
  props: {
    size: { type: [Number, String], default: 40 },
    box: { type: String, default: "#3b82f6" },
    lid: { type: String, default: "#2563eb" },
    ribbonCenter: { type: String, default: "#fde68a" },
    bowLeft: { type: String, default: "#ef4444" },
    bowRight: { type: String, default: "#f97316" },
    iconColor: { type: String, default: "#ffffff" },
    shadow: { type: String, default: "rgba(0,0,0,0.12)" },
  },
  computed: {
    svgVars() {
      return {
        "--box": this.box,
        "--bow": this.bowLeft,
      };
    },
  },
};
</script>
